export default __webpack_public_path__ + "static/media/annimation.026b0e83.webm";